// extracted by mini-css-extract-plugin
export default {"row":"createCompetition_row__2xVuJ","col":"createCompetition_col__m2i-R","card":"createCompetition_card__r4Als"};